import { combineReducers } from "redux";
// import counterReducer from 'features/example/counterSlice';
// import startUpReducer from 'features/startup/StartUpSlice';
import loginReducer from "./login/LoginSlice";
import CustomerServiceReducer from "./CustomerService/CustomerServiceSlice";
// import formDataReducer from 'features/formData/formDataSlice';
import customerReducer from "./CustomerProfile/CustomerInfoSlice";
import MasterStateSlice from "./MasterState/MasterStateSlice";
import UserDetailReducer from "./UserDetails/UserDetailsSlice";
export default combineReducers({
  /**Add more reducers here*/
  // counter: counterReducer,
  // startUp: startUpReducer,
  login: loginReducer,
  userDetail: UserDetailReducer,
  customerInfo: customerReducer,
  CustomerService: CustomerServiceReducer,
  masterstate:MasterStateSlice,
  // formData: formDataReducer,
});
